import isString from 'lodash-es/isString';
import PropTypes$1 from 'prop-types';
import React from 'react';
import { PropTypes } from '@panneau/core';
import SelectElement from '@panneau/element-select';

var propTypes = {
  field: PropTypes.field.isRequired,
  value: PropTypes$1.string,
  options: PropTypes$1.arrayOf(PropTypes$1.shape({
    label: PropTypes$1.string,
    value: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
  })),
  onChange: PropTypes$1.func
};
var defaultProps = {
  value: null,
  options: null,
  onChange: null
};
var Select = function Select(_ref) {
  var field = _ref.field,
    value = _ref.value,
    providedOptions = _ref.options,
    onChange = _ref.onChange;
  var _ref2 = field || {},
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? null : _ref2$options;
  var finalOptions = providedOptions || options || null;
  var option = (finalOptions || []).find(function (_ref3) {
    var _ref3$value = _ref3.value,
      itemValue = _ref3$value === void 0 ? null : _ref3$value;
    return itemValue === value;
  }) || null;
  var label = option !== null ? option.label : null;
  var finalLabel = isString(value) ? value : label;
  return finalOptions !== null ? /*#__PURE__*/React.createElement(SelectElement, {
    value: value,
    options: finalOptions,
    onChange: onChange
  }) : /*#__PURE__*/React.createElement("div", null, finalLabel);
};
Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export { Select as default };
